/**
 * @memberof firebird
 * @ngdoc filter
 * @name phoneFilter
 * @description
 *   Takes an unformatted phone number and returns a formatted version. Examples:
 *
 *   Input: +1PPP####### <br> Output: C (PPP) ###-####
 *
 *   Input: +CPPP####### <br> Output: CCC (PP) ###-####
 *
 *   Input: +CCCPP####### <br> Output: CCC (PP) ###-####
 */
firebird.filter('phoneFilter', function () {
    /**
     * @func phoneFilterFunc
     * @memberof phoneFilter
     * @desc
     *   This is the function that gets returned and invoked when the filter is used.
     *
     *   Takes an unformatted telephone number, and returns the
     *   country+city+number based on its initial length.
     * @param {Number|String} phoneFilterInput
     *   Unformatted telphone number.
     */
    var phoneFilterFunc = function (phoneFilterInput) {
        // return 'unknown' if no input
        if (!phoneFilterInput) {
            return 'unknown';
        }

        // Regular Expression that 'starts with'/'ends with'/and 'only contains'
        // the following phone number formatting characters
        // digits 0-9 whitespace . - \ / [ ] _ , + ( )
        var phoneNumberRegex = /^[0-9\s\.\-\\\/\[\]\_\,\+\(\)]*$/gi;

        if (phoneNumberRegex.test(phoneFilterInput.toString()) === true) {
            // format input to all the digits i.e. '+  (123) 123.1234' -> '1231231234'
            var allDigitInput = phoneFilterInput.toString().replace(/[^\d]/g, '');

            // return the original input if there are no digits in the input
            if (!allDigitInput) {
                return phoneFilterInput;
            }

            switch (allDigitInput.length) {
                case 7:
                    // format to 123-4567
                    return allDigitInput.slice(0, 3) + '-' + allDigitInput.slice(3);
                case 10:
                    // format to (123) 456-7890
                    return (
                        '(' +
                        allDigitInput.slice(0, 3) +
                        ') ' +
                        allDigitInput.slice(3, 6) +
                        '-' +
                        allDigitInput.slice(6)
                    );
                case 11:
                    if (allDigitInput[0] === '1') {
                        // format to (234) 567-8901
                        return (
                            '(' +
                            allDigitInput.slice(1, 4) +
                            ') ' +
                            allDigitInput.slice(4, 7) +
                            '-' +
                            allDigitInput.slice(7)
                        );
                    }
            }

            // return all digit string
            return allDigitInput;
        } else {
            return phoneFilterInput;
        }
    };

    return phoneFilterFunc;
});
